import { Location } from '@carbon/icons-react';
import { defineSection } from '@/app/registry';

/** Филиалы (ПОРТ-11; матрица 2.2 «Реквизиты клиники, филиалы»: OWNER — изменение; MED_DIR, OPS_DIR, FRONT_DESK, ACCOUNTANT — чтение). */
export const section = defineSection({
  id: 'org.branches',
  area: 'clinic',
  path: 'settings/branches',
  roles: ['OWNER', 'MED_DIRECTOR', 'OPS_DIRECTOR', 'FRONT_DESK', 'ACCOUNTANT'],
  icon: Location,
  titleKey: 'branches:title',
  namespaces: ['portal'],
  navGroup: 'manage',
  order: 21,
  navRoles: ['OWNER', 'MED_DIRECTOR', 'OPS_DIRECTOR', 'ACCOUNTANT'],
  tabGroup: 'clinic',
  load: () => import('./BranchesPage'),
});
